import Class from './forms';
import './forms@';

export default Class;